// MEDIA BREAKPOINTS

export const BREAKPOINT_TABLET = '768px';
export const BREAKPOINT_DESKTOP = '1200px';
